import React, { useState, useEffect } from "react";
import { TenantSettingsSidebar } from "./TenantSettingsSidebar";
import { TenantHeader } from "../Tenant/TenantHeader";
import { useSidebar } from "@/contexts/SidebarContext";
import { ScrollToTopLayout } from "../ScrollToTopLayout";

export const TenantSettingsLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isCollapsed } = useSidebar();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Sidebar genişliği (sidebar'daki w-[250px] ile eşleşmeli)
  const sidebarWidth = isCollapsed ? 56 : 250;

  return (
    <ScrollToTopLayout>
      <div className="h-screen flex flex-col bg-ds-dark">
        <TenantHeader />
        <div className="flex flex-1 overflow-hidden">
          <TenantSettingsSidebar />
          <main
            className="flex-1 overflow-auto pt-13 transition-all duration-300 max-lg:ml-0 max-lg:mt-0"
            style={{
              marginLeft: isMobile ? 0 : sidebarWidth,
            }}
          >
            <div className="px-6 py-6">
              {children}
            </div>
          </main>
        </div>
      </div>
    </ScrollToTopLayout>
  );
};

